// Topology Details panel wording: small pure helpers. No imports, so the frontend tests can compile it.

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "Sep 20" from an ISO timestamp (UTC date); "" when absent or unparseable.
export function backboneShareSinceLabel(since: string | null): string {
  if (!since) return "";
  const d = new Date(since);
  if (Number.isNaN(d.getTime())) return "";
  return `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}`;
}

// "since Sep 20 (the start of our data)"; "" when the date is unknown.
export function backboneSinceStart(since: string | null): string {
  const label = backboneShareSinceLabel(since);
  return label ? `since ${label} (the start of our data)` : "";
}

// The Traffic section holds only what the reason bullet does not (the share is already in the bullet):
// "Rank #1 of 28 in Twin Falls, since Sep 20 (the start of our data)". The unit label arrives as
// "Twin Falls region" or "#tag local scope".
export function backboneTrafficLine(regionName: string, since: string | null, rankNum: number, rankOf: number): string {
  const name = regionName.replace(/ region$/, "");
  const sinceText = backboneSinceStart(since);
  return `Rank #${rankNum} of ${rankOf} in ${name}${sinceText ? `, ${sinceText}` : ""}`;
}

export function backboneTrafficTooltip(regionName: string, since: string | null): string {
  const name = regionName.replace(/ region$/, "");
  const sinceText = backboneSinceStart(since);
  return `Packets on this repeater's links to other ${name} repeaters, counted${sinceText ? ` ${sinceText}` : ""} over links heard in the last 7 days`;
}

// "in the last 7 days" for the selected window key ("1h", "6h", "12h", "24h", "7d").
export function backboneWindowPhrase(windowKey: string): string {
  const m = /^(\d+)([hd])$/.exec(windowKey);
  if (!m) return `in the last ${windowKey}`;
  const n = Number(m[1]);
  const unit = m[2] === "h" ? (n === 1 ? "hour" : "hours") : (n === 1 ? "day" : "days");
  return n === 1 ? `in the last ${unit}` : `in the last ${n} ${unit}`;
}

// Credibility value: "Heard by 12 observers in the last 7 days".
export function backboneCredibilityValue(observers: number, windowKey: string): string {
  return `Heard by ${observers} observer${observers === 1 ? "" : "s"} ${backboneWindowPhrase(windowKey)}`;
}

// A reason bullet always ends with a full stop; a trailing note goes inside the sentence, before it.
export function backboneReasonLine(text: string, note: string): string {
  const base = text.replace(/\.$/, "");
  return `${base}${note}.`;
}
